module.exports = __webpack_public_path__ + "static/img/black-panther.0aec9dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posters/black-panther.jpg
// module id = goZq
// module chunks = 0